import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchAppViewDetails } from '../../utilities/api'
import dateFormat from 'dateformat'
import { toast } from 'react-toastify'
import moment from 'moment-timezone';
import { fetchPatientDetails } from '../../utilities/API/patientSearch/patientSearch';

export const fetchViewAppDetails = createAsyncThunk(
    'users/fetchAppView', fetchAppViewDetails
)

export const getMemberDetails = createAsyncThunk(
    'fetchPatientDetails', fetchPatientDetails
)

const initialState = {
    initialTab: 1,
    program: '',
    allowUploadDoc: false,
    isDataFetched: false,
    isPDMI: false,
    allowToSubmitClaim: false,
    applicationMessage: '',
    isPDMICardGenerated: false,
    PDMI: {
        effectiveDate: '',
        cardHolder: '',
        BIN: '',
        PCN: '',
        groupNumber: ''
    },
    viewAppInfo: {
        effStartDate_date: "--",
        lookbackDate: "--",
        awardYear: "--",
        balance: "--",
        expiryDate: "--",
        appStatus: "--",
        fund: "--",
        fundDisplayName: "--",
        fundGroup : "--",
        applicationId: '',
         RevokeDate:'--'
    },
    authPerson: [
        {
            firstName: "--",
            lastName: "--",
            relationshipToPatient: "--",
            suffix: "--",
            isAddressSameAsPatient: "--",
            isContactSameAsPatient: "--",
            isToReciveEmail: "--",
            email: '--',
            addressLine1: "--",
            State: "--",
            city: "--",
            addressLine2: "--",
            zipcode: "--",
            phoneType: "--",
            phoneNumber: "--",
        }
    ],
    treatingPhysician: {
        fullName: "--",
        facilityName: "--",
        addressLine1: "--",
        addressLine2: "--",
        city: '--',
        state: '--',
        zipCode: '--',
        dateOfDiagnosis: '--',
        PatientsCurrentMedicationList: [],
        OtherDrugName: '--',
        primaryDiagnosis: '--'
    },
    insurance: {
        insuranceAvailable: false,
        subscriberDOB: "--",
        primaryInsuranceCarrier: "--",
        primaryInsuranceOtherCarrier: "--",
        policyNumber: "--",
        planType: "--",
        applicantInsuranceType: "--",
        groupNumber: "--",
        phoneNumber: "--",
        secondaryInsuranceCarrier: "--",
        hasMedicareSupplement: "--",
        subscriberName: "--",
        secondaryInsuranceName: "--",
        hasMedicarePartD: "--",
        secondaryOtherInsuranceName: '--'
    },
    patientInfo: {
        patientId: '--',
        patientDOB: "--",
        patientName: "--",
        firstName: '--',
        lastName: '--',
        SSN: '--',
        alienNumber: '--',
        gender: "--",
        maritalStatus: "--",
        employmentStatus: "--",
        householdSize: "--",
        veteran: '--',
        hispanic: '--',
        race: '--',
        corrPreferences: "--",
        preferredLanguage: "--",
        addressLine1: "--",
        addressLine2: "--",
        city: "--",
        state: '--',
        zipCode: '--',
        phoneNumber: "--",
        phoneType: "--",
        primaryEmail: "--",
        patientSecondaryEmailAddr: "--",
        emailOwner: "--",
        emailType: "--",
        isguardianAvailable: false,
        guardianFirstName: "--",
        guardianlastName: "--",
        guardianDOB: "--",
        guardianEmploymentStatus: "--",
        relationshipToPatient: "--",
        guardianEmail: "--",
        guardianEmailType: "--",
        guardianSuffix: "--",
        guardianSSN: '--',
        guardianAlien: '--',
        isAddressSameAsPatient: "--",
        guardianAddressLine1: "--",
        guardianAddressLine2: "--",
        guardianCity: "--",
        guardianState: '--',
        guardianZipCode: '--',
        isContactSameAsPatient: "--",
        guardianPhoneNumber: "--",
        guardianPhoneType: "--",
        applicantInformation: {
            relationshipToPatient: '--',
            firstName: '--',
            lastName: '--',
            phoneNumber: '--',
        },
        referalInformation: {
            referedBy: '--',
            otherProgram: '--',
            otherProgramAssistance: '--',
            healthcareProfessional: {
                firstName: '--',
                lastName: '--',
                facility: '--',
                positionTitle: '--',
                email: '--',
                emailType: '--',
                phoneNumber: '--',
                addressLine1: "--",
                addressLine2: "--",
                city: "--",
                state: '--',
                zipCode: '--',
            }
        },
        payableInformations:{
            VerificationRequired:true,
            DefaultPayee:'',
            firstName: '',
            lastName: '',
            address: {
                isPayableAddressVerified: false,
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zipCode: ''
            }
        }
    }
}

const appViewDetailsSlice = createSlice({
    name: 'viewAppDetails',
    initialState,
    reducers: {
        resetAppViewDetails: (state) => {
            // toast.success("AppViewDetails reseted Successfully")
            state = {
                initialTab: 1,
                program: '',
                allowUploadDoc: false,
                isDataFetched: false,
                isPDMI: false,
                allowToSubmitClaim: false,
                applicationMessage: '',
                isPDMICardGenerated: false,
                PDMI: {
                    effectiveDate: '',
                    cardHolder: '',
                    BIN: '',
                    PCN: '',
                    groupNumber: ''
                },
                viewAppInfo: {
                    effStartDate_date: "--",
                    lookbackDate: "--",
                    awardYear: "--",
                    balance: "--",
                    expiryDate: "--",
                    appStatus: "--",
                    fund: "--",
                    fundDisplayName: "--",
                    fundGroup: "--",
                    applicationId: '',
                },
                authPerson: [
                    {
                        firstName: "--",
                        lastName: "--",
                        relationshipToPatient: "--",
                        suffix: "--",
                        isAddressSameAsPatient: "--",
                        isContactSameAsPatient: "--",
                        isToReciveEmail: "--",
                        email: '--',
                        addressLine1: "--",
                        State: "--",
                        city: "--",
                        addressLine2: "--",
                        zipcode: "--",
                        phoneType: "--",
                        phoneNumber: "--",
                    }
                ],
                treatingPhysician: {
                    fullName: "--",
                    facilityName: "--",
                    addressLine1: "--",
                    addressLine2: "--",
                    city: '--',
                    state: '--',
                    zipCode: '--',
                    dateOfDiagnosis: '--',
                    PatientsCurrentMedicationList: [],
                    OtherDrugName: '--',
                    primaryDiagnosis: '--'
                },
                insurance: {
                    insuranceAvailable: false,
                    subscriberDOB: "--",
                    primaryInsuranceCarrier: "--",
                    primaryInsuranceOtherCarrier: "--",
                    policyNumber: "--",
                    planType: "--",
                    applicantInsuranceType: "--",
                    groupNumber: "--",
                    phoneNumber: "--",
                    secondaryInsuranceCarrier: "--",
                    hasMedicareSupplement: "--",
                    subscriberName: "--",
                    secondaryInsuranceName: "--",
                    hasMedicarePartD: "--",
                    secondaryOtherInsuranceName: '--'
                },
                patientInfo: {
                    patientId: '--',
                    patientDOB: "--",
                    patientName: "--",
                    firstName: '--',
                    lastName: '--',
                    SSN: '--',
                    alienNumber: '--',
                    gender: "--",
                    maritalStatus: "--",
                    employmentStatus: "--",
                    householdSize: "--",
                    veteran: '--',
                    hispanic: '--',
                    race: '--',
                    corrPreferences: "--",
                    preferredLanguage: "--",
                    addressLine1: "--",
                    addressLine2: "--",
                    city: "--",
                    state: '--',
                    zipCode: '--',
                    phoneNumber: "--",
                    phoneType: "--",
                    primaryEmail: "--",
                    patientSecondaryEmailAddr: "--",
                    emailOwner: "--",
                    emailType: "--",
                    isguardianAvailable: false,
                    guardianFirstName: "--",
                    guardianlastName: "--",
                    guardianDOB: "--",
                    guardianEmploymentStatus: "--",
                    relationshipToPatient: "--",
                    guardianEmail: "--",
                    guardianEmailType: "--",
                    guardianSuffix: "--",
                    guardianSSN: '--',
                    guardianAlien: '--',
                    isAddressSameAsPatient: "--",
                    guardianAddressLine1: "--",
                    guardianAddressLine2: "--",
                    guardianCity: "--",
                    guardianState: '--',
                    guardianZipCode: '--',
                    isContactSameAsPatient: "--",
                    guardianPhoneNumber: "--",
                    guardianPhoneType: "--",
                    applicantInformation: {
                        relationshipToPatient: '--',
                        firstName: '--',
                        lastName: '--',
                        phoneNumber: '--',
                    },
                    referalInformation: {
                        referedBy: '--',
                        otherProgram: '--',
                        otherProgramAssistance: '--',
                        healthcareProfessional: {
                            firstName: '--',
                            lastName: '--',
                            facility: '--',
                            positionTitle: '--',
                            email: '--',
                            emailType: '--',
                            phoneNumber: '--',
                            addressLine1: "--",
                            addressLine2: "--",
                            city: "--",
                            state: '--',
                            zipCode: '--',
                        },
                        payableInformations:{
                            VerificationRequired:true,
                            DefaultPayee:'',
                            firstName: '',
                            lastName: '',
                            address: {
                                isPayableAddressVerified: false,
                                addressLine1: '',
                                addressLine2: '',
                                city: '',
                                state: '',
                                zipCode: ''
                            }
                        }
                    }
                }
            }
        },
        resetDataFetched: (state) => {
            state.isDataFetched = false
        },
        resetInitialTab: (state, action) => {
            state.initialTab = action.payload;
        },
        resetPDMICard: (state) => {
            state.isPDMICardGenerated = true
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchViewAppDetails.pending, (state, action) => {
                // toast.warn("app360 pending")
            })
            .addCase(fetchViewAppDetails.fulfilled, (state, action) => {
                //Award Info
                state.isDataFetched = true
                state.program = action.payload?.program
                state.isPDMI = action.payload?.res?.Fund?.ClaimsConfigurations?.PDMI?.IsAvailable == 'true'
                state.PDMI.effectiveDate = typeof action.payload?.res?.PDMIDetails?.EffectiveDate != 'undefined' ? moment(action.payload?.res?.PDMIDetails?.EffectiveDate).tz('America/New_York').format('LL') : '--'
                state.PDMI.BIN = action.payload?.res?.PDMIDetails?.BIN || '--'
                state.PDMI.PCN = action.payload?.res?.PDMIDetails?.PCN || '--'
                state.PDMI.cardHolder = action.payload?.res?.PDMIDetails?.CardHolderNumber || '--'
                state.PDMI.groupNumber = action.payload?.res?.PDMIDetails?.GroupNumber || '--'
                state.applicationMessage = action.payload?.res?.ApplicationConfirmationMessage || '--'
                state.allowToSubmitClaim = action.payload?.res?.IsEligibleForClaim == 'true' && action.payload?.program == 'CPR'
                state.allowUploadDoc = action.payload?.res?.IsEligibleForDoc == 'true' ? true : false
                state.viewAppInfo.effStartDate_date = typeof action.payload?.res?.ApprovalDateTime != 'undefined' && action.payload?.res?.ApprovalDateTime != '' ? moment(action.payload?.res?.ApprovalDateTime).tz('America/New_York').format('LL') : '--'
                state.viewAppInfo.lookbackDate = typeof action.payload?.res?.LookBackDate != 'undefined' && action.payload?.res?.LookBackDate != '' ? moment(action.payload?.res?.LookBackDate).tz('America/New_York').format('LL') : '--'
                state.viewAppInfo.awardYear = action.payload?.res?.ApprovalDateTime?.substring(0, 4) || "--"
                state.viewAppInfo.balance = action.payload?.res?.PatientBalance || "--"
                state.viewAppInfo.expiryDate = typeof action.payload?.res?.ExpirationDate != 'undefined' && action.payload?.res?.ExpirationDate != "" ? moment(action.payload?.res?.ExpirationDate).tz('America/New_York').format('LL') : '--'
                state.viewAppInfo.appStatus = action.payload?.res?.PortalStatus || "--"
                state.viewAppInfo.fund = action.payload?.res?.FundName || "--"
                state.viewAppInfo.fundGroup = action.payload?.res?.FundGroup || "--"
                state.viewAppInfo.fundDisplayName = action.payload?.res?.DisplayName || "--"
                state.viewAppInfo.applicationId = action.payload?.res?.ApplicationID || "--"  
                state.viewAppInfo.RevokeDate = action.payload?.res?.SLATimes?.ClaimSubmission?.CaseResolutionTime !=undefined && action.payload?.res?.SLATimes?.ClaimSubmission?.CaseResolutionTime !='' ? moment(action.payload?.res?.SLATimes?.ClaimSubmission?.CaseResolutionTime).tz('America/New_York').format('LL') : '--'

                //Authorized Person
                // let authPerson = action.payload?.res?.PatientInformation?.AuthPersonList
                // let arr = []
                // authPerson?.length > 0 && authPerson?.map((auth) => {
                //     const value = {
                //         firstName: auth?.pyFirstName || "--",
                //         lastName: auth?.pyLastName || "--",
                //         relationshipToPatient: auth?.RelationshipToPatient || "--",
                //         suffix: auth?.pyNameSuffix || "--",
                //         isAddressSameAsPatient: auth?.IsAddressSameAsPatient == "false" ? 'No' : 'Yes' || "--",
                //         isContactSameAsPatient: auth?.IsContactSameAsPatient == "false" ? 'No' : 'Yes' || "--",
                //         addressLine1: auth?.AuthPersonAddressList[0]?.AddressLine1 || "--",
                //         State: auth?.AuthPersonAddressList[0]?.State || "--",
                //         city: auth?.AuthPersonAddressList[0]?.City || "--",
                //         addressLine2: auth?.AuthPersonAddressList[0]?.AddressLine2 || "--",
                //         zipcode: auth?.AuthPersonAddressList[0]?.ZipCode || "--",
                //         phoneType: auth?.PhoneType || "--",
                //         phoneNumber: auth?.PhoneNumber || "--",
                //         isToReciveEmail: auth?.IsToReceiveEmail == "true" ? 'Yes' : 'No' || '--',
                //         email: auth?.pyEmail1 || '--'
                //     }
                //     arr.push(value)

                // })
                // state.authPerson = arr
                //Treating Physician
                let diagnosis = action.payload?.res?.TreatingPhysician
                let physicianAddress = diagnosis?.Address?.length > 0 && diagnosis?.Address?.filter(address => address?.pySelected == 'true')
                state.treatingPhysician.fullName = diagnosis?.FullName || "--"
                state.treatingPhysician.facilityName = diagnosis?.FacilityPracticeName || "--"
                state.treatingPhysician.addressLine1 = physicianAddress[0]?.AddressLine1 || "--"
                state.treatingPhysician.addressLine2 = physicianAddress[0]?.AddressLine2 || "--"
                state.treatingPhysician.state = physicianAddress[0]?.State || '--'
                state.treatingPhysician.city = physicianAddress[0]?.City || '--'
                state.treatingPhysician.zipCode = physicianAddress[0]?.ZipCode || '--'
                state.treatingPhysician.dateOfDiagnosis = action.payload?.res?.MedicalInformation?.DateofDiagnosis ? moment(action.payload?.res?.MedicalInformation?.DateofDiagnosis).format('LL') : '--'
                state.treatingPhysician.PatientsCurrentMedicationList = action.payload?.res?.MedicalInformation?.PatientsCurrentMedicationList || []
                state.treatingPhysician.OtherDrugName = action.payload?.res?.MedicalInformation?.OtherDrugName || '--'
                state.treatingPhysician.primaryDiagnosis = action.payload?.res?.MedicalInformation?.PrimaryDiagnosis || '--'

                // ApplicantInformation
                let applicant = action.payload?.res?.ApplicantInformation
                state.patientInfo.applicantInformation.relationshipToPatient = applicant?.RelationshipToPatient || '--'
                state.patientInfo.applicantInformation.firstName = applicant?.pyFirstName || '--'
                state.patientInfo.applicantInformation.lastName = applicant?.pyLastName || '--'
                state.patientInfo.applicantInformation.phoneNumber = applicant?.PhoneNumber || '--'

                // Referal Program
                let referal = action.payload?.res?.AdditionalInformation
                state.patientInfo.referalInformation.referedBy = referal?.CopaysReferral == "Other/Unknown" ? referal?.OtherCopay_Referral : referal?.CopaysReferral || '--'
                state.patientInfo.referalInformation.otherProgramAssistance = referal?.OtherProgramAssistance || '--'
                state.patientInfo.referalInformation.otherProgram = referal?.Program || '--'
                state.patientInfo.referalInformation.healthcareProfessional.firstName = referal?.pyFirstName || '--'
                state.patientInfo.referalInformation.healthcareProfessional.lastName = referal?.pyLastName || '--'
                state.patientInfo.referalInformation.healthcareProfessional.facility = referal?.NameofFacility || '--'
                state.patientInfo.referalInformation.healthcareProfessional.positionTitle = referal?.Title || '--'
                state.patientInfo.referalInformation.healthcareProfessional.email = referal?.PrimaryEmail || '--'
                state.patientInfo.referalInformation.healthcareProfessional.emailType = referal?.EmailType || '--'
                state.patientInfo.referalInformation.healthcareProfessional.phoneNumber = referal?.PhoneNumber || '--'
                if (typeof referal?.Address != 'undefined' && typeof referal?.Address[0] != 'undefined' && typeof referal?.Address[0]?.AddressLine1 != 'undefined') {
                    state.patientInfo.referalInformation.healthcareProfessional.addressLine1 = referal?.Address[0]?.AddressLine1 || "--"
                    state.patientInfo.referalInformation.healthcareProfessional.addressLine2 = referal?.Address[0]?.AddressLine2 || "--"
                    state.patientInfo.referalInformation.healthcareProfessional.city = referal?.Address[0]?.City || "--"
                    state.patientInfo.referalInformation.healthcareProfessional.state = referal?.Address[0]?.State || "--"
                    state.patientInfo.referalInformation.healthcareProfessional.zipCode = referal?.Address[0]?.ZipCode || "--"

                }
                
                // payable details
                state.patientInfo.payableInformations = {
                    VerificationRequired: action.payload?.res?.Fund?.ClaimsConfigurations?.ManualClaimSubmission?.VerificationRequired,
                    DefaultPayee: action.payload?.res?.Fund?.ClaimsConfigurations?.ManualClaimSubmission?.DefaultPayee,
                    firstName: action.payload?.res?.AwardPayable?.FirstName,
                    lastName: action.payload?.res?.AwardPayable?.LastName,
                }
                if (action.payload?.res?.Fund?.ClaimsConfigurations?.ManualClaimSubmission?.VerificationRequired == "false" && action.payload?.res?.Fund?.ClaimsConfigurations?.ManualClaimSubmission?.DefaultPayee) {
                    state.patientInfo.payableInformations.address = {
                        addressLine1: action.payload?.res?.AwardPayable?.Address[0]?.AddressLine1 || "--",
                        addressLine2: action.payload?.res?.AwardPayable?.Address[0]?.AddressLine2 || "--",
                        city: action.payload?.res?.AwardPayable?.Address[0]?.City || "--",
                        state: action.payload?.res?.AwardPayable?.Address[0]?.State || "--",
                        zipCode: action.payload?.res?.AwardPayable?.Address[0]?.ZipCode || "--"
                    }

        }

                //Insurance
                let viewInsuranceInfo = action.payload?.res?.InsuranceInformation
                let prequal = action.payload?.res?.PreQualification
                state.insurance.insuranceAvailable = typeof viewInsuranceInfo?.HasHealthInsurance != 'undefined' && viewInsuranceInfo.HasHealthInsurance != 'No'
                state.insurance.applicantInsuranceType = prequal?.IsApplicantInsured == "true" && prequal?.ApplicantInsuranceType || "--"
                if (viewInsuranceInfo?.HasHealthInsurance != undefined && viewInsuranceInfo.HasHealthInsurance != 'No') {
                    state.insurance.subscriberDOB = moment(viewInsuranceInfo?.SubscriberDateOfBirth).format('LL') || '--'
                    state.insurance.primaryInsuranceCarrier = viewInsuranceInfo?.PrimaryInsuranceCarrier || "--"
                    state.insurance.primaryInsuranceOtherCarrier = viewInsuranceInfo?.PrimaryInsuranceOtherCarrier || "--"
                    state.insurance.policyNumber = viewInsuranceInfo?.PolicyNumber || "--"
                    state.insurance.planType = viewInsuranceInfo?.PlanType || "--"
                    state.insurance.groupNumber = viewInsuranceInfo?.GroupNumber || "--"||""
                    state.insurance.phoneNumber = viewInsuranceInfo?.PhoneNumber || "--"
                    state.insurance.secondaryInsuranceCarrier = (viewInsuranceInfo?.SecondaryInsuranceCarrier == "true" || viewInsuranceInfo?.SecondaryInsuranceCarrier == "Yes") ? 'Yes' : 'No' || "--"
                    state.insurance.hasMedicareSupplement = (viewInsuranceInfo?.HasMedicareSupplement == "true" || viewInsuranceInfo?.HasMedicareSupplement == "Yes") ? 'Yes' : 'No' || "--"
                    state.insurance.subscriberName = viewInsuranceInfo?.SubscriberName || "--"
                    state.insurance.secondaryInsuranceName = viewInsuranceInfo?.SecondaryInsuranceInfo?.SecondaryInsuranceName || "--"
                    state.insurance.secondaryOtherInsuranceName = viewInsuranceInfo?.SecondaryInsuranceInfo?.SecondaryInsuranceOtherName || "--"
                    state.insurance.hasMedicarePartD = (viewInsuranceInfo?.HasMedicarePartD == "true" || viewInsuranceInfo?.HasMedicarePartD == "Yes") ? 'Yes' : 'No' || "--"
                }

                //Patient Info
                let viewPatientInfo = action.payload?.res?.PatientInformation
                // state.patientInfo.patientDOB = moment(viewPatientInfo?.DateOfBirth).tz('America/New_York').format('LL') || "--"
                // state.patientInfo.patientId = action.payload?.res?.MemberID || "--"
                // state.patientInfo.firstName = viewPatientInfo?.pyFirstName || '--'
                // state.patientInfo.lastName = viewPatientInfo?.pyLastName || '--'
                // state.patientInfo.SSN = viewPatientInfo?.SocialSecurityNumber || '--'
                // state.patientInfo.alienNumber = viewPatientInfo?.AlienNumber || '--'
                // state.patientInfo.patientName = viewPatientInfo?.pyFullName || "--"
                // state.patientInfo.veteran = viewPatientInfo?.VeteranClassification || '--'
                // state.patientInfo.hispanic = viewPatientInfo?.HispanicOrLatino || '--'
                let race = ""
                viewPatientInfo?.Race.length > 0 && viewPatientInfo?.Race.map((data) => {
                    if (data.pyValue != "Other") {
                        if (race != '') {
                            race = race + ', ' + data.pyValue;
                        } else {
                            race = data.pyValue
                        }
                    }
                })

                if (race != "") {
                    race = (viewPatientInfo?.OtherRace != "" && viewPatientInfo?.OtherRace != undefined) ? (race + "," + viewPatientInfo?.OtherRace) : race
                } else {
                    race = (viewPatientInfo?.OtherRace != "" && viewPatientInfo?.OtherRace != undefined) ? viewPatientInfo?.OtherRace : ""
                }
                // state.patientInfo.race = race || '--'
                // state.patientInfo.gender = viewPatientInfo?.GenderCode || "--"
                // state.patientInfo.maritalStatus = viewPatientInfo?.MaritalStatus || "--"
                // state.patientInfo.employmentStatus = viewPatientInfo?.EmploymentStatus || "--"
                // state.patientInfo.householdSize = viewPatientInfo?.HouseholdSize || "--"
                // state.patientInfo.corrPreferences = viewPatientInfo?.CorrPreferences || "--"
                // state.patientInfo.preferredLanguage = viewPatientInfo?.PreferredLanguage || "--"
                // state.patientInfo.addressLine1 = viewPatientInfo?.Address[0]?.AddressLine1 || "--"
                // state.patientInfo.addressLine2 = viewPatientInfo?.Address[0]?.AddressLine2 || "--"
                // state.patientInfo.city = viewPatientInfo?.Address[0]?.City || "--"
                // state.patientInfo.state = viewPatientInfo?.Address[0]?.State || "--"
                // state.patientInfo.zipCode = viewPatientInfo?.Address[0]?.ZipCode || "--"
                // state.patientInfo.phoneNumber = viewPatientInfo?.PhoneCommunication[0]?.PhoneNumber || "--"
                // state.patientInfo.phoneType = viewPatientInfo?.PhoneCommunication[0]?.PhoneType || "--"
                // state.patientInfo.primaryEmail = viewPatientInfo?.PrimaryEmail || "--"
                // state.patientInfo.patientSecondaryEmailAddr = viewPatientInfo?.PatientSecondaryEmailAddr || "--"
                // state.patientInfo.emailOwner = viewPatientInfo?.EmailOwner || "--"
                // state.patientInfo.emailType = viewPatientInfo?.EmailType || "--"
                // state.patientInfo.isguardianAvailable = viewPatientInfo?.HasGuardianInfo || "--"
                // state.patientInfo.employmentStatus = viewPatientInfo?.EmploymentStatus || "--"
                // if (viewPatientInfo?.HasGuardianInfo) {
                //     state.patientInfo.guardianFirstName = viewPatientInfo?.GuardianInformation?.pyFirstName || "--"
                //     state.patientInfo.guardianlastName = viewPatientInfo?.GuardianInformation?.pyLastName || "--"
                //     state.patientInfo.guardianDOB = moment(viewPatientInfo?.GuardianInformation?.DateOfBirth).tz('America/New_York').format('LL') || "--"
                //     state.patientInfo.guardianSSN = viewPatientInfo?.GuardianInformation?.SocialSecurityNumber || '--'
                //     state.patientInfo.guardianAlien = viewPatientInfo?.GuardianInformation?.AlienNumber || '--'
                //     state.patientInfo.guardianEmploymentStatus = viewPatientInfo?.GuardianInformation?.EmploymentStatus || "--"
                //     state.patientInfo.guardianEmail = viewPatientInfo?.GuardianInformation?.pyEmail1 || "--"
                //     state.patientInfo.guardianEmailType = viewPatientInfo?.GuardianInformation?.pyEmail1Type || "--"
                //     state.patientInfo.guardianSuffix = viewPatientInfo?.GuardianInformation?.pyNameSuffix || "--"
                //     state.patientInfo.relationshipToPatient = viewPatientInfo?.GuardianInformation?.RelationshipToPatient || "--"
                //     state.patientInfo.isAddressSameAsPatient = viewPatientInfo?.GuardianInformation?.IsAddressSameAsPatient == 'false' ? 'No' : 'Yes' || "--"
                //     if (typeof viewPatientInfo?.GuardianInformation != 'undefined' && typeof viewPatientInfo?.GuardianInformation?.GuardianAddressList != 'undefined' && typeof viewPatientInfo?.GuardianInformation?.GuardianAddressList[0] != 'undefined' && typeof viewPatientInfo?.GuardianInformation?.GuardianAddressList[0]?.AddressLine1 != 'undefined') {
                //         state.patientInfo.guardianAddressLine1 = viewPatientInfo?.GuardianInformation?.GuardianAddressList[0]?.AddressLine1 || "--"
                //         state.patientInfo.guardianAddressLine2 = viewPatientInfo?.GuardianInformation?.GuardianAddressList[0]?.AddressLine2 || "--"
                //         state.patientInfo.guardianCity = viewPatientInfo?.GuardianInformation?.GuardianAddressList[0]?.City || "--"
                //         state.patientInfo.guardianState = viewPatientInfo?.GuardianInformation?.GuardianAddressList[0]?.State || "--"
                //         state.patientInfo.guardianZipCode = viewPatientInfo?.GuardianInformation?.GuardianAddressList[0]?.ZipCode || "--"
                //     }

                //     state.patientInfo.isContactSameAsPatient = viewPatientInfo?.GuardianInformation?.IsContactSameAsPatient == 'false' ? 'No' : 'Yes' || "--"
                    // if (typeof viewPatientInfo?.GuardianInformation?.PhoneCommunication != 'undefined') {
                    //     if (typeof viewPatientInfo?.GuardianInformation?.PhoneCommunication[0] != 'undefined') {
                    //         state.patientInfo.guardianPhoneType = viewPatientInfo?.GuardianInformation?.PhoneCommunication[0]?.PhoneType || "--"
                    //         state.patientInfo.guardianPhoneNumber = viewPatientInfo?.GuardianInformation?.PhoneCommunication[0]?.PhoneNumber || "--"

                    //     }
                    // }

                // }


                // toast.success("app360 Fetched Successfully")
            })
            .addCase(fetchViewAppDetails.rejected, (state, action) => {
                toast.error(action.error.message)
            })
            .addCase(getMemberDetails.pending, (state, action) => {
                // toast.warn("app360 pending")
            })
            .addCase(getMemberDetails.fulfilled, (state, action) => {
                //Award Info
                // state.isDataFetched = true
                // state.program = action.payload?.program
                // state.isPDMI = action.payload?.res?.Fund?.ClaimsConfigurations?.PDMI?.IsAvailable == 'true'
                // state.PDMI.effectiveDate = typeof action.payload?.res?.PDMIDetails?.EffectiveDate != 'undefined' ? moment(action.payload?.res?.PDMIDetails?.EffectiveDate).tz('America/New_York').format('LL') : '--'
                // state.PDMI.BIN = action.payload?.res?.PDMIDetails?.BIN || '--'
                // state.PDMI.PCN = action.payload?.res?.PDMIDetails?.PCN || '--'
                // state.PDMI.cardHolder = action.payload?.res?.PDMIDetails?.CardHolderNumber || '--'
                // state.PDMI.groupNumber = action.payload?.res?.PDMIDetails?.GroupNumber || '--'
                // state.applicationMessage = action.payload?.res?.ApplicationConfirmationMessage || '--'
                // state.allowToSubmitClaim = action.payload?.res?.IsEligibleForClaim == 'true' && action.payload?.program == 'CPR'
                // state.allowUploadDoc = action.payload?.res?.IsEligibleForDoc == 'true' ? true : false
                // state.viewAppInfo.effStartDate_date = typeof action.payload?.res?.ApprovalDateTime != 'undefined' && action.payload?.res?.ApprovalDateTime != '' ? moment(action.payload?.res?.ApprovalDateTime).tz('America/New_York').format('LL') : '--'
                // state.viewAppInfo.lookbackDate = typeof action.payload?.res?.LookBackDate != 'undefined' && action.payload?.res?.LookBackDate != '' ? moment(action.payload?.res?.LookBackDate).tz('America/New_York').format('LL') : '--'
                // state.viewAppInfo.awardYear = action.payload?.res?.ApprovalDateTime?.substring(0, 4) || "--"
                // state.viewAppInfo.balance = action.payload?.res?.PatientBalance || "--"
                // state.viewAppInfo.expiryDate = typeof action.payload?.res?.ExpirationDate != 'undefined' && action.payload?.res?.ExpirationDate != "" ? moment(action.payload?.res?.ExpirationDate).tz('America/New_York').format('LL') : '--'
                // state.viewAppInfo.appStatus = action.payload?.res?.PortalStatus || "--"
                // state.viewAppInfo.fund = action.payload?.res?.FundName || "--"
                // state.viewAppInfo.fundDisplayName = action.payload?.res?.DisplayName || "--"
                // state.viewAppInfo.applicationId = action.payload?.res?.ApplicationID || "--"

                //Authorized Person
                let authPerson = action.payload?.res?.AuthPersonList
                let arr = []
                authPerson?.length > 0 && authPerson?.map((auth) => {
                    const value = {
                        firstName: auth?.pyFirstName || "--",
                        lastName: auth?.pyLastName || "--",
                        relationshipToPatient: auth?.RelationshipToPatient || "--",
                        suffix: auth?.pyNameSuffix || "--",
                        isAddressSameAsPatient: auth?.IsAddressSameAsPatient == "false" ? 'No' : 'Yes' || "--",
                        isContactSameAsPatient: auth?.IsContactSameAsPatient == "false" ? 'No' : 'Yes' || "--",
                        addressLine1: auth?.AuthPersonAddressList[0]?.AddressLine1 || "--",
                        State: auth?.AuthPersonAddressList[0]?.State || "--",
                        city: auth?.AuthPersonAddressList[0]?.City || "--",
                        addressLine2: auth?.AuthPersonAddressList[0]?.AddressLine2 || "--",
                        zipcode: auth?.AuthPersonAddressList[0]?.ZipCode || "--",
                        phoneType: auth?.PhoneType || "--",
                        phoneNumber: auth?.PhoneNumber || "--",
                        isToReciveEmail: auth?.IsToReceiveEmail == "true" ? 'Yes' : 'No' || '--',
                        email: auth?.pyEmail1 || '--'
                    }
                    arr.push(value)

                })
                state.authPerson = arr
                // //Treating Physician
                // let diagnosis = action.payload?.res?.TreatingPhysician
                // let physicianAddress = diagnosis?.Address?.length > 0 && diagnosis?.Address?.filter(address => address?.pySelected == 'true')
                // state.treatingPhysician.fullName = diagnosis?.FullName || "--"
                // state.treatingPhysician.facilityName = diagnosis?.FacilityPracticeName || "--"
                // state.treatingPhysician.addressLine1 = physicianAddress[0]?.AddressLine1 || "--"
                // state.treatingPhysician.addressLine2 = physicianAddress[0]?.AddressLine2 || "--"
                // state.treatingPhysician.state = physicianAddress[0]?.State || '--'
                // state.treatingPhysician.city = physicianAddress[0]?.City || '--'
                // state.treatingPhysician.zipCode = physicianAddress[0]?.ZipCode || '--'
                // state.treatingPhysician.dateOfDiagnosis = action.payload?.res?.MedicalInformation?.DateofDiagnosis ? moment(action.payload?.res?.MedicalInformation?.DateofDiagnosis).tz('America/New_York').format('LL') : '--'
                // state.treatingPhysician.primaryDiagnosis = action.payload?.res?.MedicalInformation?.PrimaryDiagnosis || '--'

                // ApplicantInformation
                // let applicant = action.payload?.res?.ApplicantInformation
                // state.patientInfo.applicantInformation.relationshipToPatient = applicant?.RelationshipToPatient || '--'
                // state.patientInfo.applicantInformation.firstName = applicant?.pyFirstName || '--'
                // state.patientInfo.applicantInformation.lastName = applicant?.pyLastName || '--'
                // state.patientInfo.applicantInformation.phoneNumber = applicant?.PhoneNumber || '--'

                // Referal Program
                // let referal = action.payload?.res?.AdditionalInformation
                // state.patientInfo.referalInformation.referedBy = referal?.CopaysReferral == "Other/Unknown" ? referal?.OtherCopay_Referral : referal?.CopaysReferral || '--'
                // state.patientInfo.referalInformation.otherProgramAssistance = referal?.OtherProgramAssistance || '--'
                // state.patientInfo.referalInformation.otherProgram = referal?.Program || '--'
                // state.patientInfo.referalInformation.healthcareProfessional.firstName = referal?.pyFirstName || '--'
                // state.patientInfo.referalInformation.healthcareProfessional.lastName = referal?.pyLastName || '--'
                // state.patientInfo.referalInformation.healthcareProfessional.facility = referal?.NameofFacility || '--'
                // state.patientInfo.referalInformation.healthcareProfessional.positionTitle = referal?.Title || '--'
                // state.patientInfo.referalInformation.healthcareProfessional.email = referal?.PrimaryEmail || '--'
                // state.patientInfo.referalInformation.healthcareProfessional.emailType = referal?.EmailType || '--'
                // state.patientInfo.referalInformation.healthcareProfessional.phoneNumber = referal?.PhoneNumber || '--'
                // if (typeof referal?.Address != 'undefined' && typeof referal?.Address[0] != 'undefined' && typeof referal?.Address[0]?.AddressLine1 != 'undefined') {
                //     state.patientInfo.referalInformation.healthcareProfessional.addressLine1 = referal?.Address[0]?.AddressLine1 || "--"
                //     state.patientInfo.referalInformation.healthcareProfessional.addressLine2 = referal?.Address[0]?.AddressLine2 || "--"
                //     state.patientInfo.referalInformation.healthcareProfessional.city = referal?.Address[0]?.City || "--"
                //     state.patientInfo.referalInformation.healthcareProfessional.state = referal?.Address[0]?.State || "--"
                //     state.patientInfo.referalInformation.healthcareProfessional.zipCode = referal?.Address[0]?.ZipCode || "--"

                // }
                
                // payable details
                // state.patientInfo.payableInformations={
                //     VerificationRequired:action.payload?.res?.Fund?.ClaimsConfigurations?.ManualClaimSubmission?.VerificationRequired,
                //     DefaultPayee:action.payload?.res?.Fund?.ClaimsConfigurations?.ManualClaimSubmission?.DefaultPayee,
                //     firstName: action.payload?.res?.AwardPayable?.FirstName,
                //     lastName: action.payload?.res?.AwardPayable?.LastName,
                //     address: {
                //         addressLine1: action.payload?.res?.AwardPayable?.Address[0]?.AddressLine1,
                //         addressLine2: action.payload?.res?.AwardPayable?.Address[0]?.AddressLine2,
                //         city: action.payload?.res?.AwardPayable?.Address[0]?.City,
                //         state: action.payload?.res?.AwardPayable?.Address[0]?.State,
                //         zipCode: action.payload?.res?.AwardPayable?.Address[0]?.ZipCode
                //     }
                // }

                //Insurance
                // let viewInsuranceInfo = action.payload?.res?.InsuranceInformation
                // let prequal = action.payload?.res?.PreQualification
                // state.insurance.insuranceAvailable = typeof viewInsuranceInfo?.HasHealthInsurance != 'undefined' && viewInsuranceInfo.HasHealthInsurance != 'No'
                // if (viewInsuranceInfo?.HasHealthInsurance != undefined && viewInsuranceInfo.HasHealthInsurance != 'No') {
                //     state.insurance.subscriberDOB = moment(viewInsuranceInfo?.SubscriberDateOfBirth).tz('America/New_York').format('LL') || '--'
                //     state.insurance.primaryInsuranceCarrier = viewInsuranceInfo?.PrimaryInsuranceCarrier || "--"
                //     state.insurance.primaryInsuranceOtherCarrier = viewInsuranceInfo?.PrimaryInsuranceOtherCarrier || "--"
                //     state.insurance.policyNumber = viewInsuranceInfo?.PolicyNumber || "--"
                //     state.insurance.planType = viewInsuranceInfo?.PlanType || "--"
                //     state.insurance.applicantInsuranceType = prequal?.IsApplicantInsured == "true" && prequal?.ApplicantInsuranceType || "--"
                //     state.insurance.groupNumber = viewInsuranceInfo?.GroupNumber || "--"||""
                //     state.insurance.phoneNumber = viewInsuranceInfo?.PhoneNumber || "--"
                //     state.insurance.secondaryInsuranceCarrier = (viewInsuranceInfo?.SecondaryInsuranceCarrier == "true" || viewInsuranceInfo?.SecondaryInsuranceCarrier == "Yes") ? 'Yes' : 'No' || "--"
                //     state.insurance.hasMedicareSupplement = (viewInsuranceInfo?.HasMedicareSupplement == "true" || viewInsuranceInfo?.HasMedicareSupplement == "Yes") ? 'Yes' : 'No' || "--"
                //     state.insurance.subscriberName = viewInsuranceInfo?.SubscriberName || "--"
                //     state.insurance.secondaryInsuranceName = viewInsuranceInfo?.SecondaryInsuranceInfo?.SecondaryInsuranceName || "--"
                //     state.insurance.secondaryOtherInsuranceName = viewInsuranceInfo?.SecondaryInsuranceInfo?.SecondaryInsuranceOtherName || "--"
                //     state.insurance.hasMedicarePartD = (viewInsuranceInfo?.HasMedicarePartD == "true" || viewInsuranceInfo?.HasMedicarePartD == "Yes") ? 'Yes' : 'No' || "--"
                // }

                //Patient Info
                let viewPatientInfo = action.payload?.res
                state.patientInfo.patientDOB = moment(viewPatientInfo?.DateOfBirth).format('LL') || "--" 
                state.patientInfo.patientId = action.payload?.res?.PatientID || "--"
                state.patientInfo.firstName =  viewPatientInfo.pyFirstName || '--' 
                state.patientInfo.lastName = viewPatientInfo?.pyLastName || '--'
                state.patientInfo.SSN = viewPatientInfo?.SocialSecurityNumber || '--' 
                state.patientInfo.alienNumber = viewPatientInfo?.AlienNumber || '--'
                state.patientInfo.patientName = viewPatientInfo?.pyFullName || "--"
                state.patientInfo.veteran = viewPatientInfo?.VeteranClassification || '--'
                state.patientInfo.hispanic = viewPatientInfo?.HispanicOrLatino || '--'
                let race = ""
                viewPatientInfo?.Race.length > 0 && viewPatientInfo?.Race.map((data) => {
                    if (data.pyValue != "Other") {
                        if (race != '') {
                            race = race + ', ' + data.pyValue;
                        } else {
                            race = data.pyValue
                        }
                    }
                })

                if (race != "") {
                    race = (viewPatientInfo?.OtherRace != "" && viewPatientInfo?.OtherRace != undefined) ? (race + "," + viewPatientInfo?.OtherRace) : race
                } else {
                    race = (viewPatientInfo?.OtherRace != "" && viewPatientInfo?.OtherRace != undefined) ? viewPatientInfo?.OtherRace : ""
                }
                state.patientInfo.race = race || '--'
                state.patientInfo.gender = viewPatientInfo?.GenderCode || "--" 
                state.patientInfo.maritalStatus = viewPatientInfo?.MaritalStatus || "--" 
                state.patientInfo.employmentStatus = viewPatientInfo?.EmploymentStatus || "--"
                state.patientInfo.householdSize = viewPatientInfo?.HouseholdSize || "--"
                state.patientInfo.corrPreferences = viewPatientInfo?.CorrPreferences || "--" 
                state.patientInfo.preferredLanguage = viewPatientInfo?.PreferredLanguage || "--" 
                state.patientInfo.addressLine1 = viewPatientInfo?.Address[0]?.AddressLine1 || "--" 
                state.patientInfo.addressLine2 = viewPatientInfo?.Address[0]?.AddressLine2 || "--" 
                state.patientInfo.city = viewPatientInfo?.Address[0]?.City || "--"  
                state.patientInfo.state = viewPatientInfo?.Address[0]?.State || "--" 
                state.patientInfo.zipCode = viewPatientInfo?.Address[0]?.ZipCode || "--" 
                state.patientInfo.phoneNumber = viewPatientInfo?.PhoneCommunication[0]?.PhoneNumber || "--" 
                state.patientInfo.phoneType = viewPatientInfo?.PhoneCommunication[0]?.PhoneType || "--" 
                state.patientInfo.primaryEmail = viewPatientInfo?.PrimaryEmail || "--" 
                state.patientInfo.patientSecondaryEmailAddr = viewPatientInfo?.PatientSecondaryEmailAddr || "--"
                state.patientInfo.emailOwner = viewPatientInfo?.EmailOwner || "--" 
                state.patientInfo.emailType = viewPatientInfo?.EmailType || "--" 
                state.patientInfo.isguardianAvailable = viewPatientInfo?.HasGuardianInfo || "--"
                state.patientInfo.employmentStatus = viewPatientInfo?.EmploymentStatus || "--"
                if (viewPatientInfo?.HasGuardianInfo) {
                    state.patientInfo.guardianFirstName = viewPatientInfo?.GuardianInformation?.pyFirstName || "--" 
                    state.patientInfo.guardianlastName = viewPatientInfo?.GuardianInformation?.pyLastName || "--" 
                    state.patientInfo.guardianDOB = moment(viewPatientInfo?.GuardianInformation?.DateOfBirth).format('LL') || "--" 
                    state.patientInfo.guardianSSN = viewPatientInfo?.GuardianInformation?.SocialSecurityNumber || '--' 
                    state.patientInfo.guardianAlien = viewPatientInfo?.GuardianInformation?.AlienNumber || '--'
                    state.patientInfo.guardianEmploymentStatus = viewPatientInfo?.GuardianInformation?.EmploymentStatus || "--" 
                    state.patientInfo.guardianEmail = viewPatientInfo?.GuardianInformation?.pyEmail1 || "--" 
                    state.patientInfo.guardianEmailType = viewPatientInfo?.GuardianInformation?.pyEmail1Type || "--" 
                    state.patientInfo.guardianSuffix = viewPatientInfo?.GuardianInformation?.pyNameSuffix || "--" 
                    state.patientInfo.relationshipToPatient = viewPatientInfo?.GuardianInformation?.RelationshipToPatient || "--" 
                    state.patientInfo.isAddressSameAsPatient = viewPatientInfo?.GuardianInformation?.IsAddressSameAsPatient == 'false' ? 'No' : 'Yes' || "--" 
                    if (typeof viewPatientInfo?.GuardianInformation != 'undefined' && typeof viewPatientInfo?.GuardianInformation?.GuardianAddressList != 'undefined' && typeof viewPatientInfo?.GuardianInformation?.GuardianAddressList[0] != 'undefined' && typeof viewPatientInfo?.GuardianInformation?.GuardianAddressList[0]?.AddressLine1 != 'undefined') {
                        state.patientInfo.guardianAddressLine1 = viewPatientInfo?.GuardianInformation?.GuardianAddressList[0]?.AddressLine1 || "--" 
                        state.patientInfo.guardianAddressLine2 = viewPatientInfo?.GuardianInformation?.GuardianAddressList[0]?.AddressLine2 || "--" 
                        state.patientInfo.guardianCity = viewPatientInfo?.GuardianInformation?.GuardianAddressList[0]?.City || "--" 
                        state.patientInfo.guardianState = viewPatientInfo?.GuardianInformation?.GuardianAddressList[0]?.State || "--" 
                        state.patientInfo.guardianZipCode = viewPatientInfo?.GuardianInformation?.GuardianAddressList[0]?.ZipCode || "--"  
                    }

                    state.patientInfo.isContactSameAsPatient = viewPatientInfo?.GuardianInformation?.IsContactSameAsPatient == 'false' ? 'No' : 'Yes' || "--" 
                    if (typeof viewPatientInfo?.GuardianInformation?.PhoneCommunication != 'undefined') {
                        if (typeof viewPatientInfo?.GuardianInformation?.PhoneCommunication[0] != 'undefined') {
                            state.patientInfo.guardianPhoneType = viewPatientInfo?.GuardianInformation?.PhoneCommunication[0]?.PhoneType || "--" 
                            state.patientInfo.guardianPhoneNumber = viewPatientInfo?.GuardianInformation?.PhoneCommunication[0]?.PhoneNumber || viewPatientInfo?.GuardianInformation?.PhoneCommunication[0]?.PhoneNumberInput || "--" 

                        }
                    }

                }


                // toast.success("app360 Fetched Successfully")
            })
            .addCase(getMemberDetails.rejected, (state, action) => {
                toast.error(action.error.message)
            })
    },
})

export const { resetPDMICard, resetAppViewDetails, resetDataFetched, resetInitialTab } = appViewDetailsSlice.actions

export const appViewDetails = state => state.appViewDetailsSlice
export default appViewDetailsSlice.reducer